import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { Practitionerrole } from 'app/core/interfaces/practitionerrole';

@Injectable({
  providedIn: 'root',
})
export class PractitionerroleService {
  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  public create(params: any) {
    return this.http.post(
      `${environment.apiUrl}/secretarias-practitionerrole`,
      params,
      { headers: this.getHeaders() }
    );
  }


  public createByOrganization(practitioner_id: string, organization_id: string, params: any){

    return this.http.post(
          `${environment.apiUrl}/secretarias-practitionerrole/practitioner/${practitioner_id}/organization/${organization_id}`,
          params,
          { headers: this.getHeaders() }
        );
  }

  public updateByOrganization(practitionerrole_id: string | number| undefined, organization_id: string, params: any){

    return this.http.put(
          `${environment.apiUrl}/secretarias-practitionerrole/${practitionerrole_id}/organization/${organization_id}`,
          params,
          { headers: this.getHeaders() }
        );
  }

  public findPractitionerByPractitionerroleId(id: string) {
    return this.http.get<Practitionerrole[]>(
      `${environment.apiUrl}/secretarias-practitionerrole/practitioner_id/${id}`,
      { headers: this.getHeaders() }
    );
  }

  public getTussByPrefix(params: HttpParams){
  
      return this.http.get<any[]>(`${environment.apiUrl}/secretarias-practitionerrole/tuss`, {
            params: params,
      });
  }


  public update(id: string | number | undefined, params: Practitionerrole) {
    return this.http.put(
      `${environment.apiUrl}/secretarias-practitionerrole/${id}`,
      params,
      { headers: this.getHeaders() }
    );
  }

  public delete(id: string) {
    return this.http.delete(
      `${environment.apiUrl}/secretarias-practitionerrole/${id}`,
      { headers: this.getHeaders() }
    );
  }

  public show(id: string) {
    return this.http.get<Practitionerrole>(
      `${environment.apiUrl}/secretarias-practitionerrole/${id}`,
      { headers: this.getHeaders() }
    );
  }

  public list() {
    return this.http.get(`${environment.apiUrl}/secretarias-practitionerrole`, {
      headers: this.getHeaders(),
    });
  }
}
